<mdb-select #select [options]="selectOptions" (selected)="selectUser($event)" 
    placeholder="Choose a user" class="colorful-select dropdown-primary">
</mdb-select>


// WEBPACK FOOTER //
// ./src/app/shared/user-selector/user-selector.component.html